

















































































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import { DocuSignTemplateSignHereConfigurationModel, DocuSignTemplateSignHereCreateUpdateModel, ArenaSignSignerRoleModel, Dictionary, Configuration, ValueType } from '@/types';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import { ValidationModel } from '@/types/models/validation';
export default Vue.extend({
  name: 'DocuSignUpdateTemplateSignHere',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    submitIsLoading: {
      type: Boolean,
      required: true
    },
    templateSignHereConfiguration: {
      type: Object as () => DocuSignTemplateSignHereConfigurationModel,
      required: true,
      default: {} as DocuSignTemplateSignHereConfigurationModel
    },
    templateSignHere: {
      type: Object as () => DocuSignTemplateSignHereCreateUpdateModel,
      required: true,
      default: {} as DocuSignTemplateSignHereCreateUpdateModel
    },
    serverValidationMessage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hasError: false,
      errorMessage: '',
      pageNumber: '',
      xCoord: '',
      yCoord: '',
      includeDateSigned: false,
      dateSignedXCoord: '',
      dateSignedYCoord: '',
      tabName: '',
      signerRoles: [] as ArenaSignSignerRoleModel[],
      addDateSignedField: false
    };
  },
  methods: {
    initialise() {
      this.pageNumber = String(this.templateSignHere.pageNumber);
      this.xCoord = String(this.templateSignHere.xCoord);
      this.yCoord = String(this.templateSignHere.yCoord);
      this.includeDateSigned = this.templateSignHere.includeDateSigned;
      this.dateSignedXCoord = String(this.templateSignHere.dateSignedXCoord ?? 0);
      this.dateSignedYCoord = String(this.templateSignHere.dateSignedYCoord ?? 0);
      this.tabName = this.templateSignHere.tabName;
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (!isValid || !this.validateSignerRole()) {
          return;
        }
        this.templateSignHere.templateId = this.templateId;
        this.templateSignHere.pageNumber = Number(this.pageNumber);
        this.templateSignHere.xCoord = Number(this.xCoord);
        this.templateSignHere.yCoord = Number(this.yCoord);
        this.templateSignHere.includeDateSigned = this.includeDateSigned;
        this.templateSignHere.dateSignedXCoord = Number(this.dateSignedXCoord);
        this.templateSignHere.dateSignedYCoord = Number(this.dateSignedYCoord);
        this.templateSignHere.tabName = this.tabName;
        this.$emit('submit', this.templateSignHere);
      } catch (error) {
        this.$log('Error updating template sign here', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    onCancel() {
      this.navigateToTemplateSignHereManagement();
    },
    navigateToTemplateSignHereManagement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateSignHere.Management.name,
        params: param
      });
    },
    validateSignerRole(this: any): boolean {
      this.resetFormValidation();
      if (this.templateSignHere.signerRoleId == null || this.templateSignHere.signerRoleId < 1) {
        this.addFormValidationError('Please select a Signer');
        return false;
      }
      return true;
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    }
  },
  watch: {
    serverValidationMessage(this: any, value: string) {
      if (!this.isNullOrEmpty(value)) {
        this.addFormValidationError(value);
      }
    }
  },
  created(this: any) {
    this.pageNumberValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 1,
      maxValue: 100
    } as ValidationModel;
    this.coordValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 0,
      maxValue: 10000
    } as ValidationModel;
    this.initialise();
  },
  components: {
    MStoreFormSelect
  }
});
